module.exports = __webpack_public_path__ + "static/media/light-bulb-icon.6e00c711.svg";